import { KickLogo } from "@design-system/KickLogo/KickLogo";
import classNames from "classnames";
import styles from "./MapImportedAccountsSpreadsheet.module.scss";

interface Props {
    providerHeader: React.ReactNode;
}

export const MapImportedAccountsHeader: React.FC<Props> = ({
    providerHeader,
}) => (
    <>
        <div className={classNames(styles.sheetHeader, styles.providerHeader)}>
            {providerHeader}
        </div>
        <div className={classNames(styles.sheetHeader, styles.kickHeader)}>
            <KickLogo variant="icon" size="xs" />
            Kick
        </div>
    </>
);
